(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({
          note: event.target.value
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body }
        });
      }, 300));
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  /* LOAD COMPLEMENTARY PRODUCTS */

  if (!customElements.get('product-recommendations')) {

    class ProductRecommendations extends HTMLElement {

      constructor() {
        super();

        const handleIntersection = (entries, observer) => {

          if (!entries[0].isIntersecting) return;

          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => {
              if (!response.ok) {
                throw new Error('Recommendation request failed: ' + response.status);
              }
              return response.text();
            })
            .then(text => {

              const html = document.createElement('div');
              html.innerHTML = text;

              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              } else {
                console.info('Pro Car Parts: No complementary recommendations returned.');
              }

            })
            .catch(error => {
              console.error('Pro Car Parts recommendations:', error);
            });

        };

        new IntersectionObserver(
          handleIntersection.bind(this),
          { rootMargin: '0px 0px 200px 0px' }
        ).observe(this);

      }

    }

    customElements.define('product-recommendations', ProductRecommendations);

  }

  /* QUANTITY VALIDATION */

  function procarSetQuantity(form, requestedValue) {

    const input = form.querySelector('[data-procar-qty-input]');
    if (!input) return;

    const min = Math.max(1, Number(input.min) || 1);
    const step = Math.max(1, Number(input.step) || 1);
    const max = input.max === '' ? Infinity : Number(input.max);

    const raw = Number(requestedValue);
    const requested = Number.isFinite(raw) ? raw : min;

    const requestedSteps = Math.round((requested - min) / step);

    const maximumSteps = Number.isFinite(max)
      ? Math.max(0, Math.floor((max - min) / step))
      : Infinity;

    const validSteps = Math.min(
      Math.max(0, requestedSteps),
      maximumSteps
    );

    const quantity = min + validSteps * step;

    input.value = String(quantity);

    const minus = form.querySelector('[data-procar-qty-change="minus"]');
    const plus = form.querySelector('[data-procar-qty-change="plus"]');

    if (minus) minus.disabled = quantity <= min;

    if (plus) {
      plus.disabled = Number.isFinite(max)
        ? quantity + step > max
        : false;
    }

  }

  /* PLUS AND MINUS BUTTONS */

  document.addEventListener('click', event => {

    const button = event.target.closest('[data-procar-qty-change]');
    if (!button) return;

    const form = button.closest('[data-procar-complementary-form]');
    if (!form) return;

    const input = form.querySelector('[data-procar-qty-input]');
    if (!input) return;

    const step = Math.max(1, Number(input.step) || 1);

    const delta = button.dataset.procarQtyChange === 'plus'
      ? step
      : -step;

    procarSetQuantity(form, Number(input.value) + delta);

  });

  /* MANUAL QUANTITY INPUT */

  document.addEventListener('change', event => {

    if (!event.target.matches('[data-procar-qty-input]')) return;

    const form = event.target.closest('[data-procar-complementary-form]');
    if (!form) return;

    procarSetQuantity(form, event.target.value);

  });

  /* ADD SELECTED QUANTITY TO CART */

  document.addEventListener('submit', async event => {

    const form = event.target;

    if (!form.matches('[data-procar-complementary-form]')) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.procar-upsell__status');
    const input = form.querySelector('[data-procar-qty-input]');

    if (!button || button.disabled || !input) return;

    procarSetQuantity(form, input.value);

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';
    status.textContent = '';

    const formData = new FormData(form);

    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    let useCartInterface = false;

    if (
      cart &&
      typeof cart.getSectionsToRender === 'function' &&
      typeof cart.renderContents === 'function'
    ) {

      const sections = cart.getSectionsToRender().map(section => section.id);

      if (sections.length > 0) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        useCartInterface = true;
      }

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(button);
      }

    }

    try {

      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add item'
        );
      }

      if (useCartInterface && result.sections) {

        try {

          cart.classList.remove('is-empty');
          cart.renderContents(result);
          status.textContent = 'Added to cart';

        } catch (error) {

          window.location.assign(form.dataset.cartUrl);
          return;

        }

      } else {

        window.location.assign(form.dataset.cartUrl);
        return;

      }

    } catch (error) {

      status.textContent =
        error.message || 'Please try again.';

      console.error('Pro Car Parts add to cart:', error);

    } finally {

      button.disabled = false;
      button.textContent = originalText;

    }

  });


  } catch(e) { console.error(e); }
})();
})();
